import { LoadingSkeleton } from '@joor/design-system'
import styled from 'styled-components/macro'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 20px;
`

export const LoadingOrderDetails = ({
  fieldsAmount,
}: {
  fieldsAmount: number
}) => {
  const loadingFields = new Array(fieldsAmount).fill(null).map((_, index) => (
    <div key={index}>
      <LoadingSkeleton width="40%" />
      <LoadingSkeleton />
    </div>
  ))

  return <Container>{loadingFields}</Container>
}
